import React from "react";
import BannerHero from "@/components/bannerHero";
import CareersSection from "@/components/careers/CareersSection";

const CareersPage: React.FC = () => {
    return (
        <>
            <BannerHero
                title="Careers"
                bgImage="/images/about-bg.png"
                className="about"
            />
            <CareersSection />
        </>
    );
};

export default CareersPage;
